<template>
    <div class="profile__main">
        <div class="profile__main__header">
            <h3 class="profile__main__header__title">
                ویرایش اطلاعات شخصی
            </h3>
        </div>
        <div class="profile__main__body" :class="{loading: loading}">
            <form v-bind:action="requestUri" @submit.prevent="submit(requestUri,'put')" method="post">
                <div class="row">
                    <div class="col-12 col-md-6 mb-3">
                        <simple-text label="نام" name="first_name" v-model="form.first_name" :errors="errors" />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <simple-text label="نام خانوادگی" name="last_name" v-model="form.last_name" :errors="errors" />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <simple-text label="کد ملی" name="national_code" v-model="form.national_code" :errors="errors" />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <label class="form-label">تاریخ تولد</label>
                        <date-picker v-model="form.birth_date" v-on:keydown.prevent.enter :errors="errors" format="jYYYY/jMM/jDD" type="date" />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <simple-text disabled label="شماره موبایل" name="mobile" v-model="form.mobile" :errors="errors" />
                    </div>
                    <!--<div class="col-12 col-md-6 mb-3">
                        <simple-text disabled label="آدرس ایمیل" name="email" v-model="form.email"/>
                    </div>-->
                </div>
                <button class="btn btn-primary" type="submit" :disabled="loading">
                    <span>ذخیره اطلاعات</span>
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import {simpleAjaxForm} from "../../../admin/components/general/SimpleAjaxFormMixin";

export default {
    name: "ProfileEdit",
    mixins: [simpleAjaxForm],
    data() {
        return {
            loading: false,
            form: {
                first_name: '',
                last_name: '',
                national_code: '',
                birth_date: '',
                mobile: '',
            }
        }
    },
    computed: {
        requestUri() {
            return this.route('api.profile.update');
        },
        config() {
            const token = this.token();
            return {
                headers: { Authorization: `Bearer ${token}` }
            };
        },
        authenticated() {
            return this.isAuthenticated();
        },
    },
    watch: {
        authenticated() {
            this.checkIsLoading();
        }
    },
    methods: {
        async request() {
            this.loading = true;
            await this.axios.get(this.route('api.profile.data'), this.config).then(response => {
                this.form.first_name = response.data.data.first_name;
                this.form.last_name = response.data.data.last_name;
                this.form.national_code = response.data.data.detail?.national_code;
                this.form.birth_date = response.data.data.detail?.birth_date;
                this.form.mobile = response.data.data.mobile;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.request();
    }
}
</script>

<style scoped>

</style>
